import {
  Discount,
  DiscountFailure,
  DiscountRepository,
  DiscountType,
  Either,
  left,
  right,
} from "../../domain";
import { DiscountRemoteDataSourceError } from "../core";
import { DiscountRemoteDataSource } from "../data-sources";

export class DiscountRepositoryImpl implements DiscountRepository {
  constructor(private readonly remoteDataSource: DiscountRemoteDataSource) {}

  private handleError(error: DiscountRemoteDataSourceError): DiscountFailure {
    if (error === "NetworkError") return DiscountFailure.networkFailure();
    return DiscountFailure.serverFailure();
  }

  public async add(
    type: DiscountType,
    amount: number,
    code: string,
    expiration: Date,
    phoneNumber?: string
  ): Promise<Either<DiscountFailure, null>> {
    try {
      await this.remoteDataSource.add(
        type,
        amount,
        code,
        expiration,
        phoneNumber
      );
      return right(null);
    } catch (error) {
      return left(this.handleError(error));
    }
  }

  public async remove(id: string): Promise<Either<DiscountFailure, null>> {
    try {
      await this.remoteDataSource.remove(id);
      return right(null);
    } catch (error) {
      return left(this.handleError(error));
    }
  }

  public async list(): Promise<Either<DiscountFailure, Discount[]>> {
    try {
      const res = await this.remoteDataSource.list();
      return right(res);
    } catch (error) {
      return left(this.handleError(error));
    }
  }
}
